import Logo from "../../../assets/images/logo-edp.png";
import React, { useContext, useEffect, useRef, useState } from "react";

import { IMenuModel } from "../../../models/DTO/MenuModel";

import { Accordion, Card, Container, Image, Nav, Navbar } from "react-bootstrap";
import DynamicIcon from "../../DynamicIcon/Component";
import RdContext from "../../../contexts/RdProvider";
import { RdContextType } from "../../../@types/Rd";
import isUserAuthorized, { PermissionsType, useContextCredentials } from "../../../Hooks/isUserAuthorized";
import "./Styles.scss";

function Splitter<TType>(text: string, splitter: string = ','): TType[] {
    const result: TType[] = text
        .split(splitter)
        .filter(x => x != null && x != "")
        .map(x => x as TType)
        .filter(x => x);

    return result;
}

const FilterMenus = (): IMenuModel[] => {
    const { userMenus } = useContext<RdContextType>(RdContext),
        creeds = useContextCredentials(),
        result = userMenus.filter(menu => {
            if (menu.Type == null || menu.Type == "")
                return true;

            if (menu.Type !== "") {
                const permissions: PermissionsType[] = [
                    ...(((!menu.Type.includes(",") || !menu.Type.includes(";")) && [menu.Type as PermissionsType]) || []),
                    ...((menu.Type.includes(",") && Splitter<PermissionsType>(menu.Type, ',')) || []),
                    ...((menu.Type.includes(";") && Splitter<PermissionsType>(menu.Type, ';')) || [])
                ].filter(x => x != null),
                    allowed = permissions.some((permission: PermissionsType) => isUserAuthorized({ ...creeds, role: permission }));

                return allowed;
            }

            return false;
        });

    return result;
}

const Menus = ({ items }: { items: IMenuModel[] }): JSX.Element => {

    return (
        <Accordion className="card-text" as="div" flush>
            {
                items
                    .sort((a, b) => a.Order - b.Order)
                    .map((m: IMenuModel) => m.SubMenus.length > 0 ? <SubMenu key={`menuItem-${m.Order}`} item={m} /> : <MenuItem key={`menuItem-${m.Order}`} item={m} />)
            }
        </Accordion>
    );
}

const MenuItem = ({ item }: { item: IMenuModel }): JSX.Element => {
    const eventKey: string = item.Order as any;

    return (
        <Nav.Item >
            <Nav.Link className="card-text" href={item.Url || "#"}><Accordion.Item className="card-text" eventKey={eventKey} >{item.Name}</Accordion.Item></Nav.Link>
        </Nav.Item >
    );
}

const SubMenu = ({ item }: { item: IMenuModel }): JSX.Element => {
    return (
        <>
            <RenderAccordion item={item} />
        </>
    );
}

const RenderAccordion = ({ item }: { item: IMenuModel }): JSX.Element => {
    const eventKey: string = `subMenuItem-${item.Order}`,
        subMenuRef = useRef<HTMLDivElement>(null),
        scrollToSubMenusItem: () => void = () => subMenuRef?.current != null && subMenuRef.current.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" }),
        [changeIcon, setChangeIcon] = useState(false);

    useEffect(() => { changeIcon && setTimeout(() => scrollToSubMenusItem(), 100); }, [changeIcon])

    return (
        <>
            <Accordion.Item
                className="card-text"
                as="div"
                eventKey={eventKey}
                onClick={() => setChangeIcon(prev => !prev)}
            >
                <Accordion.Header as={Card.Text}>
                    <DynamicIcon Family="RadixIcons" Name={!changeIcon ? "RxChevronRight" : "RxChevronDown"} />
                    {item.Name}
                </Accordion.Header>
                <Accordion.Body ref={subMenuRef} autoFocus={true} >
                    {
                        item.SubMenus
                            .sort((a, b) => a.Order - b.Order)
                            .map(menu => {
                                return (
                                    <Nav.Item
                                        key={`subMenu-${item.Order}-${menu.Order}`}>
                                        <DynamicIcon Family="RadixIcons" Name="RxCircle" />
                                        <Nav.Link href={menu.Url}>{menu.Name}</Nav.Link>
                                    </Nav.Item>
                                )
                            })
                    }
                </Accordion.Body>
            </Accordion.Item >

        </>
    )
}

const SideMenu = (): JSX.Element => {
    const filteredMenu: IMenuModel[] = FilterMenus();

    return (
        <Navbar id="rdSideMenu">
            <Container fluid>
                {window.innerWidth > 1280 && <Navbar.Brand href="#"><Image src={Logo} alt="EDP" rounded /> | Reuniões On-line</Navbar.Brand>}
                <Nav className="visible-xs mobile-nav me-auto" >
                    <Menus items={filteredMenu} />
                </Nav>
            </Container>
        </Navbar>
    );
}

export default SideMenu;
